import React from 'react';
import { Users } from 'lucide-react';
import EnseignantActionButtons from './EnseignantActionButtons';

const EnseignantTable = ({ 
  enseignants, 
  loading, 
  onEdit, 
  onDelete,
  onCreateAccount,
  searchTerm 
}) => {
  if (loading) {
    return (
      <div className="flex justify-center items-center p-8">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-[#202654]"></div>
      </div>
    );
  }

  return (
    <div className="overflow-x-auto">
      <table className="min-w-full divide-y divide-gray-200">
        <thead className="bg-gray-50">
          <tr>
            <th scope="col" className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
              Prénom
            </th>
            <th scope="col" className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
              Nom
            </th>
            <th scope="col" className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
              Genre
            </th>
            <th scope="col" className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
              Date naissance
            </th>
            <th scope="col" className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
              Lieu naissance
            </th>
            <th scope="col" className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
              Téléphone
            </th>
            <th scope="col" className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
              Email
            </th>
            <th scope="col" className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
              Grade
            </th>
            <th scope="col" className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
              Adresse
            </th>
            <th scope="col" className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
              Statut
            </th>
            <th scope="col" className="px-4 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">
              Actions
            </th>
          </tr>
        </thead>
        <tbody className="bg-white divide-y divide-gray-200">
          {enseignants.length === 0 ? (
            <tr>
              <td colSpan="11" className="px-6 py-12">
                <div className="flex flex-col items-center justify-center text-center">
                  <Users className="h-12 w-12 text-gray-400 mb-4" />
                  <h3 className="text-lg font-medium text-gray-900 mb-1">Aucun enseignant trouvé</h3>
                  <p className="text-sm text-gray-500 max-w-md">
                    {searchTerm ? 'Essayez avec un autre terme de recherche' : 'Commencez par ajouter votre premier enseignant'}
                  </p>
                </div>
              </td>
            </tr>
          ) : (
            enseignants.map((enseignant) => (
              <tr key={enseignant.id} className="hover:bg-gray-50 transition-colors">
                <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-900">
                  {enseignant.prenom}
                </td>
                <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-900">
                  {enseignant.nom}
                </td>
                <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-900">
                  {enseignant.genre === 'M' ? 'Masculin' : 'Féminin'}
                </td>
                <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-900">
                  {enseignant.date_naissance}
                </td>
                <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-900">
                  {enseignant.lieu_naissance}
                </td>
                <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-900">
                  {enseignant.telephone}
                </td>
                <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-900">
                  {enseignant.email}
                </td>
                <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-900">
                  <span className="px-2.5 py-1 inline-flex text-xs leading-5 font-semibold rounded-full bg-blue-100 text-blue-800">
                    {enseignant.grade?.toUpperCase()}
                  </span>
                </td>
                <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-900">
                  {enseignant.adresse}
                </td>
                <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-900">
                  {enseignant.status && (
                    <span className="px-2.5 py-1 inline-flex text-xs leading-5 font-semibold rounded-full bg-green-100 text-green-800">
                      {enseignant.status.libelle}
                    </span>
                  )}
                </td>
                <td className="px-4 py-3 whitespace-nowrap text-right text-sm font-medium">
                  <EnseignantActionButtons
                    enseignant={enseignant}
                    onEdit={onEdit}
                    onDelete={onDelete}
                    onCreateAccount={onCreateAccount}
                  />
                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
};

export default EnseignantTable; 